import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../constants";

const i18nContext = createContext({});

export function I18nProvider({ children }) {

    const [userPreferredLanguage, setUserPreferredLanguage] = useState(window.currentUserPreferredLanguage);
    const t = translations[userPreferredLanguage?.toLowerCase() || 'en'];



    return <i18nContext.Provider
        value={{ t, userPreferredLanguage, setUserPreferredLanguage }}>
        {children}
    </i18nContext.Provider>
}

export const usei18n = () => {
    const context = useContext(i18nContext);
    if (!context) {
        throw new Error("usei18n must be used within a i18nProvider");
    }
    return context;
}